import { RevealWrapper } from '@/hooks/useRevealAnimation'
import { galleryImages } from '@/mocks/gallery'

export default function GallerySection() {
  return (
    <section id="gallery" className="py-20 md:py-28 bg-background-50">
      <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-16">
        {/* Header */}
        <RevealWrapper>
          <div className="reveal text-center mb-14 md:mb-20">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-5">
              <span className="w-1.5 h-1.5 rounded-full bg-primary-500 inline-block" />
              Gallery
            </div>
            <h2 className="font-heading text-2xl md:text-4xl lg:text-5xl text-primary-700 mb-4">
              다온의 <span className="text-secondary-500">활동 공간</span>
            </h2>
            <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
              따뜻하고 편안한 공간에서 다양한 심리 지원 활동이 이루어집니다.
            </p>
          </div>
        </RevealWrapper>

        {/* Masonry-like Grid */}
        <div className="grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-5">
          {/* Left large card */}
          <RevealWrapper className="md:col-span-6 md:row-span-2">
            <div className="reveal h-full relative rounded-xl overflow-hidden group cursor-pointer">
              <img
                src={galleryImages[0].image}
                alt={galleryImages[0].title}
                className="w-full h-full min-h-[300px] md:min-h-full object-cover object-center group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-primary-900/60 via-transparent to-transparent" />
              <div className="absolute bottom-5 left-5 right-5">
                <p className="text-background-50 font-semibold text-base md:text-lg">{galleryImages[0].title}</p>
              </div>
            </div>
          </RevealWrapper>

          {/* Right top */}
          <RevealWrapper className="md:col-span-6">
            <div className="reveal reveal-delay-1 relative rounded-xl overflow-hidden group cursor-pointer">
              <img
                src={galleryImages[1].image}
                alt={galleryImages[1].title}
                className="w-full h-48 md:h-56 object-cover object-center group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-primary-900/50 via-transparent to-transparent" />
              <div className="absolute bottom-4 left-4">
                <p className="text-background-50 font-medium text-sm">{galleryImages[1].title}</p>
              </div>
            </div>
          </RevealWrapper>

          {/* Right bottom */}
          <RevealWrapper className="md:col-span-6">
            <div className="reveal reveal-delay-2 relative rounded-xl overflow-hidden group cursor-pointer">
              <img
                src={galleryImages[2].image}
                alt={galleryImages[2].title}
                className="w-full h-48 md:h-56 object-cover object-center group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-primary-900/50 via-transparent to-transparent" />
              <div className="absolute bottom-4 left-4">
                <p className="text-background-50 font-medium text-sm">{galleryImages[2].title}</p>
              </div>
            </div>
          </RevealWrapper>

          {/* Bottom row */}
          <RevealWrapper className="md:col-span-4">
            <div className="reveal relative rounded-xl overflow-hidden group cursor-pointer">
              <img
                src={galleryImages[3].image}
                alt={galleryImages[3].title}
                className="w-full h-48 md:h-56 object-cover object-center group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-primary-900/50 via-transparent to-transparent" />
              <div className="absolute bottom-4 left-4">
                <p className="text-background-50 font-medium text-sm">{galleryImages[3].title}</p>
              </div>
            </div>
          </RevealWrapper>

          <RevealWrapper className="md:col-span-4">
            <div className="reveal reveal-delay-1 relative rounded-xl overflow-hidden group cursor-pointer">
              <img
                src={galleryImages[4].image}
                alt={galleryImages[4].title}
                className="w-full h-48 md:h-56 object-cover object-center group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-primary-900/50 via-transparent to-transparent" />
              <div className="absolute bottom-4 left-4">
                <p className="text-background-50 font-medium text-sm">{galleryImages[4].title}</p>
              </div>
            </div>
          </RevealWrapper>

          <RevealWrapper className="md:col-span-4">
            <div className="reveal reveal-delay-2 relative rounded-xl overflow-hidden group cursor-pointer">
              <img
                src={galleryImages[5].image}
                alt={galleryImages[5].title}
                className="w-full h-48 md:h-56 object-cover object-center group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-primary-900/50 via-transparent to-transparent" />
              <div className="absolute bottom-4 left-4">
                <p className="text-background-50 font-medium text-sm">{galleryImages[5].title}</p>
              </div>
            </div>
          </RevealWrapper>
        </div>
      </div>
    </section>
  )
}